// ROUTES

const SITES_ROUTE = "/sites";
const TEAMS_ROUTE = "/teams";
const COACHES_ROUTE = "/coaches";
const ATHLETES_ROUTE = "/athletes";
const VIDEOS_ROUTE = "/videos";
const APP_LOGIN_ROUTE = "http://id.myplay.com";
const MYPLAY_APP_ROUTE = "https://app.myplay.com/app";
const MYPLAY_API_ROUTE = "https://api.myplay.com/api";
const MYPLAY_APP_BASE = "https://app.myplay.com/";
const MYPLAY_CCAPI_ROUTE = "https://api.myplay.com/ccapi";
const MYPLAY_SHARE_ROUTE = "https://share.myplay.com";
const MYPLAY_AD_PANEL_ROUTE = "https://manage.myplay.com"

// STRINGS

const SPORT = "sport";
const TEAM_NAME = "teamName";
const SEASON = "season";
const NAME = "name";
const JERSEY = "jersey";
const CATEGORY = "category";
const AGE = "age";
const HIGHLIGHTS_COUNT = "highlightsCount";
const TEAM = "team";
const VIDEOS_COUNT = "videosCount";
const LIVE = "live";
const SCHEDULE = "schedule";
const RECORD = "record";
const SCHEDULED_RECORDINGS = "scheduledRecordings";
const ACCESS_TOKEN = "accessToken";
const REFRESH_TOKEN = "refreshToken";
const USER_DATA = "userData";
const FULL_NAME = "fullName";
const RECORDING = "RECORDING";
const GAME = "GAME";
const TITLE = "title";
const HOME = "home";
const AWAY = "away";
const SHARE = "share";
const DELETE = "delete";
const DOWNLOAD = "download";
const ASSIGN_ASSISTANT = "AssignAssistant";
const PLAYERS_COUNT = "playersCount";
const YEAR = "year";
const UPLOAD = "upload";
const PLAYER_NUMBER = "playerNumber";
const BIRTHDATE = "birthdate";
const CLIENT_UPLOAD = "clientUpload";
const CURRENT_CLUB_ID = "currentClubId";

// CATEGORIES

const SOCCER = "soccer";
const BASKETBALL = "basketball";
const HANDBALL = "handball";
const TENNIS = "tennis";
const VOLLYBALL = "vollyball";

// NUMBERS

const VIDEOS_BULK = 20;
const TEAM_CHANNEL_GAMES_BULK_SIZE = 30;

// ACCOUNT TYPE

const PLAYER = "player";
const COACH = "coach";
const OPERATOR = "operator";

// PARAMS

const GCS_UPLOADED = "GCS_UPLOADED";
const GCS_UPLOADING = "GCS_UPLOADING";
const CHECKSUM = "checksum";


export {
  SITES_ROUTE,
  TEAMS_ROUTE,
  COACHES_ROUTE,
  ATHLETES_ROUTE,
  VIDEOS_ROUTE,
  TEAM_NAME,
  SEASON,
  SPORT,
  NAME,
  JERSEY,
  CATEGORY,
  AGE,
  HIGHLIGHTS_COUNT,
  TEAM,
  VIDEOS_COUNT,
  LIVE,
  SCHEDULE,
  RECORD,
  SCHEDULED_RECORDINGS,
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  USER_DATA,
  APP_LOGIN_ROUTE,
  FULL_NAME,
  SOCCER,
  BASKETBALL,
  HANDBALL,
  TENNIS,
  VOLLYBALL,
  RECORDING,
  GAME,
  TITLE,
  VIDEOS_BULK,
  MYPLAY_APP_ROUTE,
  HOME,
  AWAY,
  SHARE,
  DELETE,
  DOWNLOAD,
  ASSIGN_ASSISTANT,
  PLAYERS_COUNT,
  YEAR,
  PLAYER,
  COACH,
  OPERATOR,
  UPLOAD,
  GCS_UPLOADED,
  CHECKSUM,
  MYPLAY_API_ROUTE,
  MYPLAY_CCAPI_ROUTE,
  MYPLAY_APP_BASE, 
  PLAYER_NUMBER, 
  BIRTHDATE, 
  TEAM_CHANNEL_GAMES_BULK_SIZE, 
  CLIENT_UPLOAD, 
  GCS_UPLOADING,
  MYPLAY_SHARE_ROUTE,
  CURRENT_CLUB_ID,
  MYPLAY_AD_PANEL_ROUTE
};
